/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProcessOfferPrintRealizationByDatesRequestDto } from '../models';
// @ts-ignore
import type { UpdateOfferPrintTemplateRequestDto } from '../models';
/**
 * RestProcessOfferFileGeneratorApi - axios parameter creator
 */
export const RestProcessOfferFileGeneratorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate offer file
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {string} [processOfferId] 
         * @param {string} [printMode] PACKAGE offers only. &#x60;SELECTION&#x60; &#x3D; full dish pool with a checkbox per dish; &#x60;SELECTED&#x60; &#x3D; only the customer-picked dishes. Omitted &#x3D; standard print (all dishes, no checkboxes). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOfferFile: async (userId: string, processId: string, multiProcessOfferGroupId: string, processOfferId?: string, printMode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('generateOfferFile', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('generateOfferFile', 'processId', processId)
            // verify required parameter 'multiProcessOfferGroupId' is not null or undefined
            assertParamExists('generateOfferFile', 'multiProcessOfferGroupId', multiProcessOfferGroupId)
            const localVarPath = `/api/processes/{processId}/offers-groups/{multiProcessOfferGroupId}/file`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{multiProcessOfferGroupId}', encodeURIComponent(String(multiProcessOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (processOfferId !== undefined) {
                localVarQueryParameter['processOfferId'] = processOfferId;
            }

            if (printMode !== undefined) {
                localVarQueryParameter['printMode'] = printMode;
            }

            localVarHeaderParameter['Accept'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate offer files
         * @param {string} userId 
         * @param {ProcessOfferPrintRealizationByDatesRequestDto} processOfferPrintRealizationByDatesRequestDto Process offer print realization by dates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOfferFiles: async (userId: string, processOfferPrintRealizationByDatesRequestDto: ProcessOfferPrintRealizationByDatesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('generateOfferFiles', 'userId', userId)
            // verify required parameter 'processOfferPrintRealizationByDatesRequestDto' is not null or undefined
            assertParamExists('generateOfferFiles', 'processOfferPrintRealizationByDatesRequestDto', processOfferPrintRealizationByDatesRequestDto)
            const localVarPath = `/api/offers/realization-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/zip';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferPrintRealizationByDatesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate realization offer file
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRealizationOfferFile: async (userId: string, processId: string, processOfferId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('generateRealizationOfferFile', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('generateRealizationOfferFile', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('generateRealizationOfferFile', 'processOfferId', processOfferId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/realization-file`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets the template the offer print is built from. With `processOfferId` the template is stored as that single offer\'s own override; without it the template is stored on the whole multi-offer group. This mirrors how `generateOfferFile` resolves the template — the offer\'s own override first, the group\'s template as the fallback — so the level written here is the level the print actually reads. 
         * @summary Assign the offer print template used when generating the offer PDF
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {UpdateOfferPrintTemplateRequestDto} updateOfferPrintTemplateRequestDto Offer print template assignment request
         * @param {string} [processOfferId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferPrintTemplate: async (userId: string, processId: string, multiProcessOfferGroupId: string, updateOfferPrintTemplateRequestDto: UpdateOfferPrintTemplateRequestDto, processOfferId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateOfferPrintTemplate', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateOfferPrintTemplate', 'processId', processId)
            // verify required parameter 'multiProcessOfferGroupId' is not null or undefined
            assertParamExists('updateOfferPrintTemplate', 'multiProcessOfferGroupId', multiProcessOfferGroupId)
            // verify required parameter 'updateOfferPrintTemplateRequestDto' is not null or undefined
            assertParamExists('updateOfferPrintTemplate', 'updateOfferPrintTemplateRequestDto', updateOfferPrintTemplateRequestDto)
            const localVarPath = `/api/processes/{processId}/offers-groups/{multiProcessOfferGroupId}/print-template`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{multiProcessOfferGroupId}', encodeURIComponent(String(multiProcessOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (processOfferId !== undefined) {
                localVarQueryParameter['processOfferId'] = processOfferId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOfferPrintTemplateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestProcessOfferFileGeneratorApi - functional programming interface
 */
export const RestProcessOfferFileGeneratorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestProcessOfferFileGeneratorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generate offer file
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {string} [processOfferId] 
         * @param {string} [printMode] PACKAGE offers only. &#x60;SELECTION&#x60; &#x3D; full dish pool with a checkbox per dish; &#x60;SELECTED&#x60; &#x3D; only the customer-picked dishes. Omitted &#x3D; standard print (all dishes, no checkboxes). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOfferFile(userId: string, processId: string, multiProcessOfferGroupId: string, processOfferId?: string, printMode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOfferFile(userId, processId, multiProcessOfferGroupId, processOfferId, printMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferFileGeneratorApi.generateOfferFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate offer files
         * @param {string} userId 
         * @param {ProcessOfferPrintRealizationByDatesRequestDto} processOfferPrintRealizationByDatesRequestDto Process offer print realization by dates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOfferFiles(userId: string, processOfferPrintRealizationByDatesRequestDto: ProcessOfferPrintRealizationByDatesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOfferFiles(userId, processOfferPrintRealizationByDatesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferFileGeneratorApi.generateOfferFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate realization offer file
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateRealizationOfferFile(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateRealizationOfferFile(userId, processId, processOfferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferFileGeneratorApi.generateRealizationOfferFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets the template the offer print is built from. With `processOfferId` the template is stored as that single offer\'s own override; without it the template is stored on the whole multi-offer group. This mirrors how `generateOfferFile` resolves the template — the offer\'s own override first, the group\'s template as the fallback — so the level written here is the level the print actually reads. 
         * @summary Assign the offer print template used when generating the offer PDF
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {UpdateOfferPrintTemplateRequestDto} updateOfferPrintTemplateRequestDto Offer print template assignment request
         * @param {string} [processOfferId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOfferPrintTemplate(userId: string, processId: string, multiProcessOfferGroupId: string, updateOfferPrintTemplateRequestDto: UpdateOfferPrintTemplateRequestDto, processOfferId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOfferPrintTemplate(userId, processId, multiProcessOfferGroupId, updateOfferPrintTemplateRequestDto, processOfferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferFileGeneratorApi.updateOfferPrintTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestProcessOfferFileGeneratorApi - factory interface
 */
export const RestProcessOfferFileGeneratorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestProcessOfferFileGeneratorApiFp(configuration)
    return {
        /**
         * 
         * @summary Generate offer file
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {string} [processOfferId] 
         * @param {string} [printMode] PACKAGE offers only. &#x60;SELECTION&#x60; &#x3D; full dish pool with a checkbox per dish; &#x60;SELECTED&#x60; &#x3D; only the customer-picked dishes. Omitted &#x3D; standard print (all dishes, no checkboxes). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOfferFile(userId: string, processId: string, multiProcessOfferGroupId: string, processOfferId?: string, printMode?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generateOfferFile(userId, processId, multiProcessOfferGroupId, processOfferId, printMode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate offer files
         * @param {string} userId 
         * @param {ProcessOfferPrintRealizationByDatesRequestDto} processOfferPrintRealizationByDatesRequestDto Process offer print realization by dates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOfferFiles(userId: string, processOfferPrintRealizationByDatesRequestDto: ProcessOfferPrintRealizationByDatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generateOfferFiles(userId, processOfferPrintRealizationByDatesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate realization offer file
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRealizationOfferFile(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generateRealizationOfferFile(userId, processId, processOfferId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the template the offer print is built from. With `processOfferId` the template is stored as that single offer\'s own override; without it the template is stored on the whole multi-offer group. This mirrors how `generateOfferFile` resolves the template — the offer\'s own override first, the group\'s template as the fallback — so the level written here is the level the print actually reads. 
         * @summary Assign the offer print template used when generating the offer PDF
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {UpdateOfferPrintTemplateRequestDto} updateOfferPrintTemplateRequestDto Offer print template assignment request
         * @param {string} [processOfferId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferPrintTemplate(userId: string, processId: string, multiProcessOfferGroupId: string, updateOfferPrintTemplateRequestDto: UpdateOfferPrintTemplateRequestDto, processOfferId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOfferPrintTemplate(userId, processId, multiProcessOfferGroupId, updateOfferPrintTemplateRequestDto, processOfferId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestProcessOfferFileGeneratorApi - interface
 */
export interface RestProcessOfferFileGeneratorApiInterface {
    /**
     * 
     * @summary Generate offer file
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {string} [processOfferId] 
     * @param {string} [printMode] PACKAGE offers only. &#x60;SELECTION&#x60; &#x3D; full dish pool with a checkbox per dish; &#x60;SELECTED&#x60; &#x3D; only the customer-picked dishes. Omitted &#x3D; standard print (all dishes, no checkboxes). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateOfferFile(userId: string, processId: string, multiProcessOfferGroupId: string, processOfferId?: string, printMode?: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Generate offer files
     * @param {string} userId 
     * @param {ProcessOfferPrintRealizationByDatesRequestDto} processOfferPrintRealizationByDatesRequestDto Process offer print realization by dates request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateOfferFiles(userId: string, processOfferPrintRealizationByDatesRequestDto: ProcessOfferPrintRealizationByDatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Generate realization offer file
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateRealizationOfferFile(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Sets the template the offer print is built from. With `processOfferId` the template is stored as that single offer\'s own override; without it the template is stored on the whole multi-offer group. This mirrors how `generateOfferFile` resolves the template — the offer\'s own override first, the group\'s template as the fallback — so the level written here is the level the print actually reads. 
     * @summary Assign the offer print template used when generating the offer PDF
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {UpdateOfferPrintTemplateRequestDto} updateOfferPrintTemplateRequestDto Offer print template assignment request
     * @param {string} [processOfferId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOfferPrintTemplate(userId: string, processId: string, multiProcessOfferGroupId: string, updateOfferPrintTemplateRequestDto: UpdateOfferPrintTemplateRequestDto, processOfferId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestProcessOfferFileGeneratorApi - object-oriented interface
 */
export class RestProcessOfferFileGeneratorApi extends BaseAPI implements RestProcessOfferFileGeneratorApiInterface {
    /**
     * 
     * @summary Generate offer file
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {string} [processOfferId] 
     * @param {string} [printMode] PACKAGE offers only. &#x60;SELECTION&#x60; &#x3D; full dish pool with a checkbox per dish; &#x60;SELECTED&#x60; &#x3D; only the customer-picked dishes. Omitted &#x3D; standard print (all dishes, no checkboxes). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateOfferFile(userId: string, processId: string, multiProcessOfferGroupId: string, processOfferId?: string, printMode?: string, options?: RawAxiosRequestConfig) {
        return RestProcessOfferFileGeneratorApiFp(this.configuration).generateOfferFile(userId, processId, multiProcessOfferGroupId, processOfferId, printMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate offer files
     * @param {string} userId 
     * @param {ProcessOfferPrintRealizationByDatesRequestDto} processOfferPrintRealizationByDatesRequestDto Process offer print realization by dates request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateOfferFiles(userId: string, processOfferPrintRealizationByDatesRequestDto: ProcessOfferPrintRealizationByDatesRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOfferFileGeneratorApiFp(this.configuration).generateOfferFiles(userId, processOfferPrintRealizationByDatesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate realization offer file
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateRealizationOfferFile(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig) {
        return RestProcessOfferFileGeneratorApiFp(this.configuration).generateRealizationOfferFile(userId, processId, processOfferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets the template the offer print is built from. With `processOfferId` the template is stored as that single offer\'s own override; without it the template is stored on the whole multi-offer group. This mirrors how `generateOfferFile` resolves the template — the offer\'s own override first, the group\'s template as the fallback — so the level written here is the level the print actually reads. 
     * @summary Assign the offer print template used when generating the offer PDF
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {UpdateOfferPrintTemplateRequestDto} updateOfferPrintTemplateRequestDto Offer print template assignment request
     * @param {string} [processOfferId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOfferPrintTemplate(userId: string, processId: string, multiProcessOfferGroupId: string, updateOfferPrintTemplateRequestDto: UpdateOfferPrintTemplateRequestDto, processOfferId?: string, options?: RawAxiosRequestConfig) {
        return RestProcessOfferFileGeneratorApiFp(this.configuration).updateOfferPrintTemplate(userId, processId, multiProcessOfferGroupId, updateOfferPrintTemplateRequestDto, processOfferId, options).then((request) => request(this.axios, this.basePath));
    }
}

